// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3m2Bq","approved":"Status_approved__3jqU0","rejected":"Status_rejected__3vj7a","expired":"Status_expired__17hRv","label":"Status_label__f8fkn"};